import React from 'react';
import clsx from 'clsx';

import { SvgPropsWithoutRef } from '../../common/types';

export enum IconSize {
  small = 'small',
  medium = 'medium',
  large = 'large'
}

export interface IconProps extends Omit<SvgPropsWithoutRef, 'size'> {
  /**
   * Размер Icon ("small", "medium", "large")
   */
  size?: IconSize;
  /**
   * Компонент иконки
   * @type React.ElementType
   */
  icon?: React.ElementType;
  /**
   * Цвет иконки
   */
  color?: string;
  /**
   * Реф на корневой элемент
   */
  innerRef?: React.Ref<SVGSVGElement>;
}

export function Icon({
  size = IconSize.medium,
  className,
  icon: Icon,
  innerRef,
  style,
  color,
  ...props
}: IconProps) {
  if (!Icon) {
    return null;
  }
  const iconStyle: React.CSSProperties = style || {};
  if (color) iconStyle.color = color;

  return (
    <Icon
      ref={innerRef}
      className={clsx(className, 'hse-Icon', {
        [`hse-Icon_size_${size}`]: size
      })}
      size={size}
      style={iconStyle}
      {...props}
    />
  );
}

Icon.Size = IconSize;
